import React, {useState} from 'react';
import {DependentLists} from './../../../models/DependentLists';
import {
  MenuItem,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Checkbox,
} from '@material-ui/core';
import ActionsMenu from 'Shared/components/PagedView/ActionsMenu';
import {maskTaxId} from 'Shared/utilities/taxIdMasker';
import {maskPhoneNumber} from 'Shared/utilities/phoneNumberMasker';
import {useDispatch} from 'react-redux';
import {removeDependent} from 'ApplicationEntry/ducks/dependentLists';
import DependentMaintenanceDialog from './DependentMaintenanceDialog';
import {updateDependentValues} from 'ApplicationEntry/ducks/dependents';
import {Dependents} from 'ApplicationEntry/models/Dependents';
import DateUtility from 'Shared/utilities/DateUtility';
import {maskZipCode} from 'ApplicationEntry/models/ZipCode';
import {updateDependentList} from 'ApplicationEntry/ducks/dependentLists';
import {Product} from 'ApplicationEntry/models/ProductsRiders/PlanModel';

type TabularProps = {
  DependentItems: DependentLists;
  selectedPolicyList: Product[];
  isQuality: boolean;
};

export default function TabularList(props: TabularProps) {
  const dispatch = useDispatch();

  const [openDeleteBox, setOpenDeleteBox] = useState(false);
  const [Index, setIndex] = useState(0);
  const [openEditBox, setOpenEditBox] = useState(false);

  const handleClickOpen = (index: number) => {
    setOpenDeleteBox(true);
    setIndex(index);
  };

  const handleEditDependent = (index: number) => {
    setIndex(index);
    const dependentItems = props.DependentItems.dependentList.get(index) as Dependents;

    dispatch(
      updateDependentValues(
        dependentItems.firstName,
        dependentItems.middleName,
        dependentItems.lastName,
        dependentItems.relationship,
        dependentItems.sex,
        maskTaxId(dependentItems.socialSecurityNumber.value),
        dependentItems.dob,
        dependentItems.phone,
        dependentItems.address,
        dependentItems.addressLine2,
        dependentItems.city,
        dependentItems.state,
        dependentItems.zip,
        dependentItems.occSmokerCode,
        dependentItems.accidentDependent,
        dependentItems.cancerDependent,
        dependentItems.shopDependent
      )
    );
    setOpenEditBox(true);
  };

  const handleClose = () => {
    setOpenDeleteBox(false);
    setOpenEditBox(false);
  };
  const dependent = props.DependentItems.dependentList.get(Index) as Dependents;

  const accidentProduct = props.selectedPolicyList.some(product => product.friendlyName == 'group_acc');
  const cancerProduct = props.selectedPolicyList.some(product => product.friendlyName == 'group_cancer');
  const shopProduct = props.selectedPolicyList.some(product => product.friendlyName == 'group_shop');

  const getColumnHeaderDependentAccident = () => {
    return accidentProduct ? 'A' : '';
  };
  const getColumnHeaderDependentCancer = () => {
    return cancerProduct ? 'C' : '';
  };
  const getColumnHeaderDependentShop = () => {
    return shopProduct ? 'S' : '';
  };
  return (
    <>
      <TableContainer component={Paper}>
        <Table className="dependents-section__table">
          <TableHead>
            <TableRow>
              <TableCell>First Name</TableCell>
              <TableCell>{props.isQuality ? 'M.I' : 'Middle Name'}</TableCell>
              <TableCell>Last Name</TableCell>
              <TableCell>Sex</TableCell>
              <TableCell>SSN</TableCell>
              <TableCell>Relationship</TableCell>
              <TableCell>{!props.isQuality && 'Address'}</TableCell>
              <TableCell>{!props.isQuality && 'Address Line 2'}</TableCell>
              <TableCell>{!props.isQuality && 'City'}</TableCell>
              <TableCell>{!props.isQuality && 'State'}</TableCell>
              <TableCell>{!props.isQuality && 'Zip'}</TableCell>
              <TableCell>{!props.isQuality && 'Phone'}</TableCell>
              <TableCell>DOB</TableCell>
              <TableCell>{!props.isQuality && 'AGE'}</TableCell>
              <TableCell>{!props.isQuality && getColumnHeaderDependentAccident()}</TableCell>
              <TableCell>{!props.isQuality && getColumnHeaderDependentCancer()}</TableCell>
              <TableCell>{!props.isQuality && getColumnHeaderDependentShop()}</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.DependentItems.dependentList.map((item, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  {item.firstName.value}
                </TableCell>
                <TableCell>{item.middleName.value}</TableCell>
                <TableCell>{item.lastName.value}</TableCell>
                <TableCell>{item.sex}</TableCell>
                <TableCell>{maskTaxId(item.socialSecurityNumber.value)}</TableCell>
                <TableCell>{item.relationship.value}</TableCell>
                <TableCell>{!props.isQuality && item.address.value}</TableCell>
                <TableCell>{!props.isQuality && item.addressLine2}</TableCell>
                <TableCell>{!props.isQuality && item.city.value}</TableCell>
                <TableCell>{!props.isQuality && item.state.value}</TableCell>
                <TableCell>{!props.isQuality && maskZipCode(item.zip.value)}</TableCell>
                <TableCell>{!props.isQuality && maskPhoneNumber(item.phone.phoneNumber)}</TableCell>
                <TableCell>{DateUtility.toFormattedDate(item.dob)}</TableCell>
                <TableCell>{!props.isQuality && item.dob ? DateUtility.getAgeFromDob(item.dob) : ''}</TableCell>

                <TableCell>
                  {accidentProduct && !props.isQuality ? (
                    <Checkbox
                      onChange={e => {
                        dispatch(updateDependentList({...item, accidentDependent: e.target.checked}, index));
                      }}
                      checked={item.accidentDependent}
                      name="checkedAccident"
                      color="secondary"
                    />
                  ) : (
                    ''
                  )}
                </TableCell>
                <TableCell>
                  {cancerProduct && !props.isQuality ? (
                    <Checkbox
                      onChange={e => {
                        dispatch(updateDependentList({...item, cancerDependent: e.target.checked}, index));
                      }}
                      checked={item.cancerDependent}
                      name="checkedCancer"
                      color="secondary"
                    />
                  ) : (
                    ''
                  )}
                </TableCell>
                <TableCell>
                  {shopProduct && !props.isQuality ? (
                    <Checkbox
                      onChange={e => {
                        dispatch(updateDependentList({...item, shopDependent: e.target.checked}, index));
                      }}
                      checked={item.shopDependent}
                      name="checkedShop"
                      color="secondary"
                    />
                  ) : (
                    ''
                  )}
                </TableCell>

                <TableCell id="dependents-table-actions">
                  <ActionsMenu>
                    <MenuItem
                      id="dependents-table-actions-edit"
                      key="dependent-edit"
                      onClick={() => handleEditDependent(index)}
                    >
                      Edit
                    </MenuItem>
                    <MenuItem
                      id="dependents-table-actions-delete"
                      key="dependent-delete"
                      onClick={() => handleClickOpen(index)}
                    >
                      Delete
                    </MenuItem>
                  </ActionsMenu>
                </TableCell>
              </TableRow>
            ))}

            <TableRow>
              <TableCell className="dependents-section__table-total-count">Item Count:</TableCell>
              <TableCell className="dependents-section__table-total-count">
                {props.DependentItems.dependentList.size}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {props.DependentItems.dependentList.size > 0 ? (
        <Dialog
          open={openDeleteBox}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary" style={{color: 'red'}}>
            Delete Dependent
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Dependent will be removed from the list. Do you want to delete{' '}
              <span style={{fontWeight: 'bold'}}>
                {dependent.firstName.value} {dependent.lastName.value}?
              </span>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                setOpenDeleteBox(false);
                setIndex(0);
                dispatch(removeDependent(Index));
              }}
              color="primary"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
      <DependentMaintenanceDialog
        dialogOpen={openEditBox}
        dialogClose={handleClose}
        dialogTitle="Add Dependent(s)"
        dialogSubTitle="Dependent(s) Information"
        dialogAdditional="ADDITIONAL DEPENDENT"
        dependentIndex={Index}
        editDependent={openEditBox}
      />
    </>
  );
}
